var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caret-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5203 7.53175L8.43444 13.2664C8.51365 13.3588 8.61191 13.433 8.72248 13.4838C8.83304 13.5347 8.9533 13.561 9.07499 13.561C9.19669 13.561 9.31694 13.5347 9.4275 13.4838C9.53807 13.433 9.63633 13.3588 9.71554 13.2664L14.6297 7.53175C15.0987 6.98436 14.7098 6.13885 13.9891 6.13885H4.15944C3.43874 6.13885 3.04991 6.98436 3.5203 7.53175Z",
    fill: "#8493B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDropDown);
export default __webpack_public_path__ + "static/media/caret-drop-down.c4ebbf2c990bef23acfdc1d240f8cf7f.svg";
export { ForwardRef as ReactComponent };